import { ArtifactOptions } from "../../types";
import { Artifact } from "./Artifact";
import PureCampaignBuilder from "@/Apps/Funnels/CampaignBuilder/PureCampaignBuilder";

const CampaignBuilderArtifactContainer = ({ objects }: { objects: any[] }) => (
  <div className="h-full w-full max-w-6xl overflow-y-auto gap-4 flex-col flex p-6">
    <PureCampaignBuilder
      id="campaign-builder"
      objects={objects}
      onChange={() => {}}
      deleteConnection={() => {}}
      updateObject={() => {}}
      deleteObject={() => {}}
      createConnection={() => {}}
      createObject={() => {}}
      getNodeDropdownItems={() => {}}
    />
  </div>
);

export const CampaignBuilderArtifact = ({
  action = "",
  prompt = "",
  objects = [],
  setArtifactOptions = () => {},
}: {
  action: string;
  prompt: string;
  objects: any[];
  setArtifactOptions: (options: ArtifactOptions) => void;
}) => {
  return (
    <div>
      <Artifact
        type="campaign builder"
        title="Campaign Builder"
        // onClick={onClick}
        setArtifactOptions={() =>
          setArtifactOptions({
            id: "campaign-builder",
            isShowing: true,
            title: "Campaign Builder",
            type: "campaign builder",
            component: () => <CampaignBuilderArtifactContainer objects={objects} />,
          })
        }
      />
    </div>
  );
};
